import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { trans } from "../../utils";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DataTableComp from "../../../DataTables";
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Collapse,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";

const isArabic = localStorage.getItem('lang') === 'ar';
const textplace = isArabic ? "text-left" : "";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const steps = [
  {
    label: trans("The process has not started yet"),
    description:<div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("On the way to the health authority"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("The shipment was received from the Health Authority"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("The shipment was approved from the Health Authority"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("On the way to treatment"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("The waste was delivered for treatment"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
  {
    label: trans("The received shipment has been approved"),
    description: <div><h5>{trans("DHL Express")}</h5> <p>{trans("Al Jazirah - Corniche Road, Jeddah")}</p></div>,
  },
];
function createData(name, calories, fat, carbs) {
  return { name, calories, fat, carbs };
}
const rows = [
  createData(trans("Toxic waste"), trans("Drugs"), trans("kg"), <button className="btn btn btn-secondary" aria-disabled="true">{trans("edit")}</button>),
  createData(trans("Toxic waste"), trans("Drugs"), trans("kg"), <button className="btn btn btn-secondary" aria-disabled="true">{trans("edit")}</button>),
  createData(trans("Toxic waste"), trans("Drugs"), trans("kg"), <button className="btn btn btn-secondary" aria-disabled="true">{trans("edit")}</button>),
  createData(trans("Toxic waste"), trans("Drugs"), trans("kg"), <button className="btn btn btn-secondary" aria-disabled="true">{trans("edit")}</button>),
];


const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 24,
  height: 24,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: theme.palette.primary.main,
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.primary.main,
  }),
}));

function StepIcon(props) {
  const { active, completed, className } = props;
  
  return (
    <StepIconRoot ownerState={{ completed, active }} className={className}>
      <CircleIcon className="p-1"/>
    </StepIconRoot>
  );
}

StepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  className: PropTypes.string,
};

const CollapsiblePanel = ({ title, details }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className="mb-3" onClick={handleExpandClick}>
      <CardHeader
        title={title}
        className={`border-bottom border-dark h-100px d-flex `}
        action={
          <div>
            <IconButton>
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            {expanded ? trans("Hide details") : trans("View details")}
          </div>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>{details}</CardContent>
      </Collapse>
    </Card>
  );
};

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <div className="row py-5 px-3">
          <div className={`col-6 ${textplace} pb-4`}>
            <button
              className="btn btn btn-secondary rounded-pill"
              aria-disabled="true">
              {trans("Shipment received from the Health Authority")}
            </button>
          </div>
          <h4 className={`col-6 ${textplace} pb-4`}>
            LME24190# {trans("Operation")}
          </h4>
          <div className={`col-6 ${textplace}`}></div>
          <div className={`col-6 ${textplace}`}>
            <div className="row">
              <div className="col-6">{trans("Creation date")}</div>
              <div className="col-6">{trans("Last activity by")}</div>
              <div className="col-6">
                11:00 {trans("AM")}. 12 {trans("December")} 2023
              </div>
              <div className="col-6">
                {trans("Mohammad Hesham,")}{trans(" shipping representative")}
              </div>
            </div>
          </div>
        </div>
      </Box>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example">
          <Tab label={trans("Order status log")} {...a11yProps(0)} />
          <Tab label={trans("Assigned parties")} {...a11yProps(1)} />
          <Tab label={trans("Waste details")} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        <Box sx={{ maxWidth: 400 }}>
          <Stepper activeStep={0} orientation="vertical">
            {steps.map((step) => (
              <Step key={step.label}>
                <StepLabel StepIconComponent={StepIcon}>
                  {step.label}
                </StepLabel>
                <StepContent>
                  <Typography>{step.description}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CollapsiblePanel
          title={
            <div className={`${textplace}`}>
              <p className="Wastetitel">{trans("DHL Express Company")}</p>
              <p className="Wastedes">{trans("Shipping company")}</p>
            </div>
          }
          details={
            <>
              <p className="Wastetitel">{trans("Health Authority - Hospital")}</p>
              <div className="d-flex justify-content-between">
                <div>
                  <p>{trans("Address details")}</p>
                  <p>{trans("22231 Al Jazirah - Corniche Road, Jeddah")}</p>
                </div>
                <div>
                  <p>{trans("Contact number")}</p>
                  <p>+966 12 653 3333</p>
                </div>
                <div>
                  <p>{trans("Email")}</p>
                  <p>label@system.com</p>
                </div>
              </div>
            </>
          }
        />
        <CollapsiblePanel
          title={
            <div className={`${textplace}`}>
              <p className="Wastetitel">{trans("DHL Express Company")}</p>
              <p className="Wastedes">{trans("Shipping company")}</p>
            </div>
          }
          details={
            <>
              <p className="Wastetitel">{trans("Health Authority - Hospital")}</p>
              <div className="d-flex justify-content-between">
                <div>
                  <p>{trans("Address details")}</p>
                  <p>{trans("22231 Al Jazirah - Corniche Road, Jeddah")}</p>
                </div>
                <div>
                  <p>{trans("Contact number")}</p>
                  <p>+966 12 653 3333</p>
                </div>
                <div>
                  <p>{trans("Email")}</p>
                  <p>label@system.com</p>
                </div>
              </div>
            </>
          }
        />
        <CollapsiblePanel
          title={
            <div className={`${textplace}`}>
              <p className="Wastetitel">{trans("DHL Express Company")}</p>
              <p className="Wastedes">{trans("Shipping company")}</p>
            </div>
          }
          details={
            <>
              <p className="Wastetitel">{trans("Health Authority - Hospital")}</p>
              <div className="d-flex justify-content-between">
                <div>
                  <p>{trans("Address details")}</p>
                  <p>{trans("22231 Al Jazirah - Corniche Road, Jeddah")}</p>
                </div>
                <div>
                  <p>{trans("Contact number")}</p>
                  <p>+966 12 653 3333</p>
                </div>
                <div>
                  <p>{trans("Email")}</p>
                  <p>label@system.com</p>
                </div>
              </div>
            </>
          }
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 550 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{trans("Name of toxic medical waste")}</TableCell>
            <TableCell align="right">{trans("Waste category")}</TableCell>
            <TableCell align="right">{trans("Number of waste")}</TableCell>
            <TableCell align="right">{trans("Action")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      </CustomTabPanel>
    </Box>
  );
}
